import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=f65b7b02&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=ts&"
export * from "./Welcome.vue?vue&type=script&lang=ts&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=f65b7b02&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65b7b02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
installComponents(component, {VCard,VCardText})
